<template>
  <div class="thematic">
    <div
      class="nav-wrap"
      :style="{
        'background-image': 'url(' + getUrl(specialTemData.specialBannerPath) + ')'
      }"
    >
      <div class="back" @click="toBack">
        <i class="el-icon-arrow-left"></i>
        返回模版库
      </div>
      <h3>{{ specialTemData.specialTitle }}</h3>
    </div>
    <el-row type="flex" justify="center">
      <el-col :span="20">
        <CardList ref="cardList" :templateList="templateList" isThematic/>
        <!-- 分页 -->
        <el-pagination
          class="text-right"
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[6, 12, 18, 24]"
          :page-size="pagination.pageSize"
          :pager-count="5"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pagination.total"
        >
        </el-pagination>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import CardList from './components/CardList.vue'
import { getSpecialById, getSpecialTemById } from '@/api/wenjuan/template-library.js'

export default {
  name: 'thematic',
  components: { CardList },
  props: {},
  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 12,
        total: 0
      },
      templateList: [],
      specialTemData: []
    }
  },
  watch: {},
  computed: {
    getUrl() {
      return function (url) {
        let baseUrl = window.location.origin
        return baseUrl + '/fill/api/v1/download?fileName=' + url
      }
    },
    id() {
      return this.$route.params.id
    },
    getParams() {
      return {
        specialId: this.id,
        size: this.pagination.pageSize,
        current: this.pagination.currentPage
      }
    }
  },
  methods: {
    getSpecialById() {
      getSpecialById(this.id)
        .then(result => {
          this.specialTemData = result.data.data
        })
        .catch(err => {})
    },
    getSpecialTemById() {
      this.$refs.cardList?.setLoading(true)
      getSpecialTemById(this.getParams).then(res => {
        if (res.data.code != 0) {
          return
        }
        this.templateList = res.data.data.records
        this.pagination.total = res.data.data.total
        this.$refs.cardList?.setLoading(false)
      })
    },
    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.getSpecialTemById()
    },
    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.getSpecialTemById()
    },
    toBack() {
      this.$router.push({
        path: '/template/all'
      })
    }
  },
  mounted() {
    this.getSpecialById()
    this.getSpecialTemById()
  }
}
</script>
<style lang="scss" scoped>
.thematic {
  @apply bg-white;
  .nav-wrap {
    height: 188px;
    line-height: 188px;
    @apply w-full text-center bg-no-repeat bg-center bg-cover relative;
    .back {
      width: 92px;
      height: 26px;
      border: 1px solid #ffffff;
      border-radius: 13px;
      line-height: 26px;
      left: 120px;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.2);
      text-shadow: 0 1px 1px rgba(0, 0, 0, 0.2);
      @apply font-medium text-small text-white absolute top-4 cursor-pointer;
    }
    h3 {
      font-size: 40px;
      letter-spacing: 6px;
      text-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
      @apply font-semibold text-white;
    }
  }
}
</style>
